import Vue from 'vue'
import VueGooglePlaces from 'vue-google-places'

Vue.use(VueGooglePlaces)
